<template>
    <div class="h-100">
        <div class="d-flex ms-3 mb-3">
            <div class="mt-1">Layout Editor</div>

            <div class="m-1">
                | View: <strong>{{view.name}}</strong>
            </div>
            <div class="m-1">
                | Layout: {{view.view_type}}
            </div>

            <div class="ms-2">
                <button class="btn btn-sm btn-primary" @click="onSaveClick">save</button>
            </div>

            <div class="ms-1">
                <router-link :to="{ name: 'view-renderer', params: {id: view.id}}" :key="view.id + 'ViewLink'"
                             class="btn btn-sm btn-primary">
                    open
                </router-link>
            </div>

        </div>

        <div class="row mx-0 h-100">

            <div class="col-2 bg-light">
            </div>

            <div v-if="table && layout" class="col-7 center-container mb-5 bg-light">
                <h5>{{viewModel.renderType}}</h5>

<!--                <div v-if="viewModel.renderType === 'Mobile'" class="marvel-device iphone-x">-->
<!--                    <div class="notch">-->
<!--                        <div class="camera"></div>-->
<!--                        <div class="speaker"></div>-->
<!--                    </div>-->
<!--                    <div class="top-bar"></div>-->
<!--                    <div class="sleep"></div>-->
<!--                    <div class="bottom-bar"></div>-->
<!--                    <div class="volume"></div>-->
<!--                    <div class="overflow">-->
<!--                        <div class="shadow shadow&#45;&#45;tr"></div>-->
<!--                        <div class="shadow shadow&#45;&#45;tl"></div>-->
<!--                        <div class="shadow shadow&#45;&#45;br"></div>-->
<!--                        <div class="shadow shadow&#45;&#45;bl"></div>-->
<!--                    </div>-->
<!--                    <div class="inner-shadow"></div>-->
<!--                    <div class="screen">-->
<!--                        <gallery-renderer v-if="table" :table="table" :view="view" :layout="layout.gallery"-->
<!--                                          :column-count="currentLayout.columnCount"></gallery-renderer>-->
<!--                    </div>-->
<!--                </div>-->


                <div v-if="viewModel.renderType === 'Mobile'" style="width: 375px; height: 800px"
                     class="shadow border border-light rounded-lg bg-white pt-3">



<!--                    <svg width="334px" height="13px" viewBox="0 0 334 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
<!--                            <g id="Notch/Top/Black-Status-Bar" transform="translate(-27.000000, -17.000000)">-->
<!--                                <g id="Status-Bar-Black">-->
<!--                                    <rect id="Base" x="0" y="0" width="375" height="44"></rect>-->
<!--                                    <g id="Battery" transform="translate(336.000000, 17.000000)">-->
<!--                                        <rect id="Border" stroke="#000000" opacity="0.35" x="0.5" y="0.833333333" width="21" height="10.3333333" rx="2.66666675"></rect>-->
<!--                                        <path d="M23,4 L23,8 C23.8047311,7.66122348 24.328038,6.87313328 24.328038,6 C24.328038,5.12686672 23.8047311,4.33877652 23,4" id="Cap" fill="#000000" fill-rule="nonzero" opacity="0.4"></path>-->
<!--                                        <rect id="Capacity" fill="#000000" fill-rule="nonzero" x="2" y="2.33333333" width="18" height="7.33333333" rx="1.33333337"></rect>-->
<!--                                    </g>-->
<!--                                    <path d="M323.330333,19.608 C325.546226,19.6080971 327.677386,20.4595347 329.283333,21.9863333 C329.404265,22.1042079 329.597562,22.102721 329.716667,21.983 L330.872667,20.8163333 C330.932975,20.7556112 330.966599,20.6733595 330.966104,20.5877792 C330.965598,20.5021988 330.931014,20.420346 330.87,20.3603333 C326.654902,16.3207858 320.005098,16.3207858 315.79,20.3603333 C315.728941,20.4203015 315.694297,20.5021294 315.693727,20.5877099 C315.693171,20.6732903 315.726736,20.755567 315.787,20.8163333 L316.943333,21.983 C317.062362,22.1029017 317.255808,22.1043897 317.376667,21.9863333 C318.982819,20.4594344 321.114223,19.6079944 323.330333,19.608 L323.330333,19.608 Z M323.330333,23.4036667 C324.547823,23.4035921 325.721865,23.8561245 326.624333,24.6733333 C326.746397,24.7893139 326.938678,24.7867994 327.057667,24.6676667 L328.212333,23.501 C328.273141,23.439805 328.30688,23.3567887 328.30602,23.2705239 C328.305126,23.1842592 328.269706,23.101946 328.207667,23.042 C325.459468,20.4856177 321.203532,20.4856177 318.455333,23.042 C318.393256,23.1019453 318.357837,23.1842997 318.357008,23.2705923 C318.356208,23.356885 318.390065,23.4398934 318.451,23.501 L319.605333,24.6676667 C319.724322,24.7867994 319.916603,24.7893139 320.038667,24.6733333 C320.940539,23.8566645 322.113649,23.4041708 323.330333,23.4036667 L323.330333,23.4036667 Z M325.549333,26.188 C325.611087,26.127394 325.645095,26.0439919 325.643328,25.957485 C325.641561,25.8709782 325.604176,25.7890342 325.54,25.731 C324.264428,24.6521162 322.396238,24.6521162 321.120667,25.731 C321.056446,25.7889875 321.019,25.8709057 321.01717,25.957413 C321.01534,26.0439203 321.049289,26.1273487 321.111,26.188 L323.108667,28.2036667 C323.167217,28.2629057 323.247042,28.2962443 323.330333,28.2962443 C323.413624,28.2962443 323.49345,28.2629057 323.552,28.2036667 L325.549333,26.188 Z" id="Wifi" fill="#000000" fill-rule="nonzero"></path>-->
<!--                                    <path d="M294.666667,24.3333333 L295.666667,24.3333333 C296.218951,24.3333333 296.666667,24.7810486 296.666667,25.3333333 L296.666667,27.3333333 C296.666667,27.8856181 296.218951,28.3333333 295.666667,28.3333333 L294.666667,28.3333333 C294.114382,28.3333333 293.666667,27.8856181 293.666667,27.3333333 L293.666667,25.3333333 C293.666667,24.7810486 294.114382,24.3333333 294.666667,24.3333333 L294.666667,24.3333333 Z M299.333333,22.3333333 L300.333333,22.3333333 C300.885618,22.3333333 301.333333,22.7810486 301.333333,23.3333333 L301.333333,27.3333333 C301.333333,27.8856181 300.885618,28.3333333 300.333333,28.3333333 L299.333333,28.3333333 C298.781049,28.3333333 298.333333,27.8856181 298.333333,27.3333333 L298.333333,23.3333333 C298.333333,22.7810486 298.781049,22.3333333 299.333333,22.3333333 Z M304,20 L305,20 C305.552285,20 306,20.4477153 306,21 L306,27.3333333 C306,27.8856181 305.552285,28.3333333 305,28.3333333 L304,28.3333333 C303.447715,28.3333333 303,27.8856181 303,27.3333333 L303,21 C303,20.4477153 303.447715,20 304,20 Z M308.666667,17.6666667 L309.666667,17.6666667 C310.218951,17.6666667 310.666667,18.1143819 310.666667,18.6666667 L310.666667,27.3333333 C310.666667,27.8856181 310.218951,28.3333333 309.666667,28.3333333 L308.666667,28.3333333 C308.114382,28.3333333 307.666667,27.8856181 307.666667,27.3333333 L307.666667,18.6666667 C307.666667,18.1143819 308.114382,17.6666667 308.666667,17.6666667 L308.666667,17.6666667 Z" id="Cellular-Connection" fill="#000000" fill-rule="nonzero"></path>-->
<!--                                    <path d="M31.9325196,29.2709961 C29.9256836,29.2709961 28.365625,28.0771484 28.0653321,26.3193359 L30.2552735,26.3193359 C30.4603516,27.0151367 31.1195313,27.4545898 31.947168,27.4545898 C33.3973633,27.4545898 34.2762696,26.0556641 34.2323242,23.8583984 L34.1004883,23.8583984 C33.6170899,24.8544922 32.6356446,25.418457 31.4051758,25.418457 C29.3983399,25.418457 27.9261719,23.9389648 27.9261719,21.9174805 C27.9261719,19.7202148 29.603418,18.1601562 31.9691406,18.1601562 C33.4925781,18.1601562 34.7230469,18.8266602 35.4554688,20.0644531 C36.0414063,20.9726562 36.3416992,22.1884766 36.3416992,23.6313477 C36.3416992,27.1469727 34.6864258,29.2709961 31.9325196,29.2709961 Z M31.9837891,23.7119141 C33.0897461,23.7119141 33.9027344,22.9282227 33.9027344,21.8662109 C33.9027344,20.796875 33.0750977,19.9692383 31.9911133,19.9692383 C30.9071289,19.9692383 30.072168,20.7895508 30.072168,21.8442383 C30.072168,22.9282227 30.8778321,23.7119141 31.9837891,23.7119141 Z M39.4547852,27.9306641 C40.2458008,27.9306641 40.7511719,27.3959961 40.7511719,26.65625 C40.7511719,25.9165039 40.2458008,25.3891602 39.4547852,25.3891602 C38.6710938,25.3891602 38.1583984,25.9165039 38.1583984,26.65625 C38.1583984,27.3959961 38.6710938,27.9306641 39.4547852,27.9306641 Z M39.4547852,22.5253906 C40.2458008,22.5253906 40.7511719,21.9907227 40.7511719,21.2509766 C40.7511719,20.5112305 40.2458008,19.9838867 39.4547852,19.9838867 C38.6710938,19.9838867 38.1583984,20.5112305 38.1583984,21.2509766 C38.1583984,21.9907227 38.6710938,22.5253906 39.4547852,22.5253906 Z M47.7680664,29 L47.7680664,27.1542969 L42.597168,27.1542969 L42.597168,25.1987305 C43.5493164,23.4042969 44.9262695,21.2216797 46.7792969,18.4311523 L49.8774414,18.4311523 L49.8774414,25.315918 L51.2617188,25.315918 L51.2617188,27.1542969 L49.8774414,27.1542969 L49.8774414,29 L47.7680664,29 Z M44.5820312,25.2646484 L44.5820312,25.3818359 L47.8193359,25.3818359 L47.8193359,20.1523438 L47.7021484,20.1523438 C46.7353516,21.5952148 45.7905273,23.074707 44.5820312,25.2646484 Z M55.2317383,29 L57.4436523,29 L57.4436523,18.4311523 L55.2390625,18.4311523 L52.5071289,20.3134766 L52.5071289,22.371582 L55.0999023,20.5844727 L55.2317383,20.5844727 L55.2317383,29 Z" id="Time" fill="#000000"></path>-->
<!--                                </g>-->
<!--                            </g>-->
<!--                        </g>-->
<!--                    </svg>-->

                    <gallery-renderer v-if="table" :table="table" :view="view" :layout="layout.gallery"
                                      :column-count="currentLayout.columnCount"></gallery-renderer>
                </div>
                <div v-else>
                    <gallery-renderer v-if="table" :table="table" :view="view" :layout="layout.gallery"
                                      :column-count="currentLayout.columnCount"></gallery-renderer>
                </div>

            </div>

            <layout-property-editor v-if="table && layout" :view-model="viewModel" :layout="layout"
                                    :table="table"></layout-property-editor>


        </div>

    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import LayoutFactory from "../../utils/LayoutFactory";
    import LayoutUtil from "../../utils/LayoutUtil";
    import GalleryView from "../../views/gallery/GalleryView.vue";
    import GalleryRenderer from "../../views/gallery/GalleryRenderer.vue";
    import LayoutPropertyEditor from "./LayoutPropertyEditor.vue";
    import GalleryModelFactory from "./GalleryModelFactory";

    export default {
        name: 'LayoutEditor',
        components: {LayoutPropertyEditor, GalleryRenderer, GalleryView},
        data() {
            return {
                model: webase.model,
                service: new ViewService(),
                view: {
                    id: null,
                    name: '',
                    view_type: '',
                },
                table: null,
                viewModel: {
                    renderType: 'Mobile'
                },
                layout: null
            }
        },
        computed: {
            currentLayout() {
                return this.viewModel.renderType === 'Mobile' ? this.layout.gallery.mobile : this.layout.gallery.desktop
            }
        },
        mounted() {
            let viewId = this.$route.params.id

            this.service.get(viewId).then((view) => {

                let description = ''

                if (view.layout.description === undefined) {
                    view.layout.description = description
                } else {
                    description = view.layout.description
                }

                if (view.layout.rows) {
                    let layoutUtil = new LayoutUtil()
                    layoutUtil.initConditions(view.layout)
                }

                this.view = view
                let app = view.app
                console.log('LayoutEditor init app')
                webase.utils.app.initAppProperties(app)
                this.model.app = app
                this.table = webase.utils.array.get(this.model.app.tables, this.view.model_id)

                let factory = new GalleryModelFactory(this.table)
                this.layout = factory.newLayout()

                // if(this.view.layout.rows) {
                //     this.layout = this.view.layout
                //     this.clearSelections()  // deselect everything
                // }
                // else {
                //     let factory = new LayoutFactory(this.table)
                //     this.layout = factory.createLayout(this.view)
                // }

                // this.layout.description = description // ensure description is preserved

            }).catch((message) => {
                console.log('error loading view')
                console.log(message)
            })

            // webase.eventDispatcher.on('updateBackgroundClick', this.onSetBackgroundClick)
            // webase.eventDispatcher.on('editBackgroundPatternClick', this.onEditBackgroundPatternClick)
            // webase.eventDispatcher.on('editAnimationClick', this.onEditAnimationClick)
            // webase.eventDispatcher.on('addEmojiClick', this.onAddEmojiClick)
            // this.timerId = setInterval(this.onSaveClick, 5000);
        },
        beforeUnmount() {
            // webase.eventDispatcher.off('updateBackgroundClick', this.onSetBackgroundClick)
            // webase.eventDispatcher.off('editBackgroundPatternClick', this.onEditBackgroundPatternClick)
            // webase.eventDispatcher.off('editAnimationClick', this.onEditAnimationClick)
            // webase.eventDispatcher.off('addEmojiClick', this.onAddEmojiClick)
            //
            // if(this.timerId) {
            //     clearInterval(this.timerId)
            // }
            //
            // this.timerId = null
            // this.onSaveClick()
            // this.clearSelections()
        },
        methods: {
            // clearSelections() {
            //     console.log('ViewEditor, clear selections')
            //     webase.utils.layout.deselectAll(this.layout)
            //     this.layout.selectedComponent = null
            //     this.layout.selectedColumn = null
            //     this.layout.selectedRow = null
            // },
            onSaveClick() {
                if (this.view.id === null) {
                    return
                }

                let request = {
                    view: {
                        layout: this.layout
                    }
                }

                this.service.update(this.view.id, request).catch((message) => {
                    console.log('error updating view')
                    console.log(message)
                })
            },
            onResetClick() {
                this.layout = {}
                this.onSaveClick()
                let factory = new LayoutFactory(this.table)
                this.layout = factory.createLayout(this.view)
            }
        }
    }
</script>
